/** Máximo de filas de datos (sin encabezado) por archivo en importación v1. */
export const CSV_IMPORT_MAX_ROWS = 2000;

/** Tamaño de lote para commits locales antes de continuar UI. */
export const CSV_IMPORT_BATCH_SIZE = 50;

export const UTF8_BOM = '\uFEFF';
